import {FC, useState, useEffect} from 'react'

type Props = {
  logs: any
}

const HistoryContent: FC<Props> = ({logs}) => {
  return (
    <div className='card'>
      <div className='p-7 border-bottom'>
        <div className='d-flex align-items-center gap-3'>
          <div className='icon-box px-4 py-2 rounded' style={{backgroundColor: '#EBF3FA'}}>
            <i className='fa fa-history text-dark'></i>
          </div>
          <p className='fs-4 fw-bold'>Riwayat</p>
        </div>
      </div>
      <div className='p-10 table-responsive'>
        <table className='table table-striped align-middle'>
          <thead>
            <tr>
              <th>Nama</th>
              <th>Penilai</th>
              <th>Tanggal</th>
              <th>Jenis</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {logs?.length > 0 ? (
              logs?.map((item: any, index: number) => {
                return (
                  <tr key={index}>
                    <td>{item?.nama ?? '-'}</td>
                    <td>{item?.penilai ?? '-'}</td>
                    <td>{item?.tanggal}</td>
                    <td>{item?.tipe}</td>
                    <td>{item?.status}</td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td className='text-center' colSpan={5}>
                  Tidak ada data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const History: FC<Props> = ({logs}) => {
  return <HistoryContent logs={logs} />
}

export default History
